import { Practitioner as WaitlistPractitioner } from '@dreryk/egabinet-waitlist-frontend-api';
import { PractitionerView } from '@dreryk/egabinet-personnel-frontend-api';

export const isPractitionerView = (
   practitioner: WaitlistPractitioner | PractitionerView
): practitioner is PractitionerView => {
   return typeof practitioner.id === 'number';
};
